export enum ProgramsListColumns {
  'ID' = 'ID',
  'PROGRAM_NAME' = 'Program Name',
  'BUSINESS' = 'Business',
  'DATES' = 'Dates',
  'REWARDS' = 'Rewards',
  'STATUS' = 'Status'
}

export const PROGRAMS_TITLE = 'Programs'
export const CREATE_PROGRAM_BUTTON_LABEL = 'New Program'
export const CREATE_PROGRAM_FORM_TITLE = 'Create a New Program'
export const CREATE_PROGRAM_FORM_BUTTON_LABEL = 'Create Program'
export const EDIT_PROGRAM_FORM_TITLE = 'Edit Program Information'
export const EDIT_PROGRAM_FORM_BUTTON_LABEL = 'Update Information'
export const PROGRAM = 'Program'
export const PROGRAM_INFORMATION = 'Program Information'
export const UPDATE_PROGRAM_TITLE = 'Update Program'

export const PROGRAM_FORM_TEXT = {
  CREATE: {
    TITLE: 'New Program',
    BTN_LABEL: 'Create Program',
    DIALOG_TITLE: 'Create a new Program',
    DIALOG_MSG: 'Create the new program'
  },
  EDIT: {
    TITLE: 'Edit Program',
    BTN_LABEL: 'Update Program',
    DIALOG_TITLE: 'Edit Program',
    DIALOG_MSG: 'Edit the program'
  }
}
export const PROGRAM_FORM_FIELDS = {
  IMAGE: {
    ID: 'Image',
    LABEL: 'Program Image',
    PLACEHOLDER: 'Image'
  },
  NAME: {
    ID: 'Name',
    LABEL: 'Program Name',
    PLACEHOLDER: 'Name'
  },
  EMAIL: {
    ID: 'Email',
    LABEL: 'Email',
    PLACEHOLDER: 'Email'
  },
  DESCRIPTION: {
    ID: 'Description',
    LABEL: 'Description',
    PLACEHOLDER: 'Description'
  }
}

export const CREATE_OR_EDIT_PROGRAM_TITLES = {
  PROGRAM_INFORMATION: 'Program Information',
  PROGRAM_DATE: 'Program Date',
  ACCESS_TO_PROGRAM: 'Access to the Program',
  REWARD_SETTINGS: 'Reward Settings',
  CODE_INFORMATION: 'Code Information',
  CODE_GENERATION_METHOD: 'Generation of Codes',
  SCAN_RECEIPT: 'Scanning a purchase receipt',
  EDIT_AVAILABLE_CODES: 'Edit list of Available Codes'
}

export const CREATE_OR_EDIT_PROGRAM_SUBTITLES = {
  PROGRAM_INFORMATION:
    'Provide the following information related to the Program.',
  PROGRAM_DATE: 'Provide the following information related to the Program.',
  ACCESS_TO_PROGRAM:
    'Select how the user can enter the Program. Both options can be selected.',
  REWARD_SETTINGS:
    'Provide the information related to the Reward the user will receive when joining the Program.',
  CODE_INFORMATION: 'Provide the information required to set up the Codes.',
  CODE_GENERATION_METHOD:
    'Provide the following information to create the New Codes for this Program.',
  SCAN_RECEIPT: 'Set the rules for accepting a valid receipt.',
  EDIT_AVAILABLE_CODES:
    'Select the type of modification to make to the list of codes that are currently available.'
}

export const CREATE_OR_EDIT_PROGRAM_FIELD_TITLES = {
  BUSINESS_USER_ID: 'Business',
  NAME: 'Name',
  DESCRIPTION: 'Description',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  JOIN_TYPE: 'How the users will join the Program',
  DISTRIBUTION_TYPE: 'Value to Distribute',
  PARTICIPANTS_LIMIT: 'Limit the times the user can participate in the Program',
  VALUE_OF_TRIP: 'Value of Trip (in USD)',
  NUMBER_OF_CODES: 'Number of codes to Issue',
  CODE_GENERATION_METHOD: 'Type of Code to Generate',
  PREFIX: 'Code Prefix (optional)',
  CODE_LENGTH: 'Random section length',
  EXCLUDED_CHARACTERS: 'Characters to exclude (optional)',
  AVAILABLE_CODES: 'Available Codes',
  TYPE_OF_CODES: 'Type of Codes',
  NUMBER_OF_NEW_CODES: 'Number of new codes to generate',
  SET_PURCHASE_DAY: 'Select a specific day when the purchase needs to happen',
  SET_PURCHASE_TIME:
    'Select a specific time frame when the purchase needs to happen',
  SET_RECEIPT_AMOUNT: 'Set a specific Receipt Amount',
  NUMBER_OF_RECEIPTS: 'Number of receipts to reward'
}

export const RETRIEVE_PROGRAMS_ERROR_MSG =
  'Something went wrong while fetching programs. Please try again.'
export const RETRIEVE_PROGRAMS_CODES_ERROR_MSG =
  'Something went wrong while fetching program codes. Please try again.'
export const DEFAULT_PROGRESS = 0
export const RETRIEVE_PROGRAMS_ACTION = 'RETRIEVE_PROGRAMS'

export const PROGRAMS_FILTERS_KEYS = {
  SEARCH: 'search',
  PROGRAM: 'selectedProgram',
  STATUSES: 'selectedStatuses',
  BUSINESS_USERS: 'selectedBusinessUsers',
  SEARCH_PROGRAM_NAME: 'searchProgramName'
}
export const PROGRAM_STATUSES = {
  LIVE: 'Live',
  HIDDEN: 'Hidden',
  EXPIRED: 'Expired',
  DISABLED: 'Disabled'
}
export const PROGRESS_BAR_CAP = 90
export const PROGRESS_INTERVAL_DELAY = 3000
export const MAX_PROGRESS = 100

export const PROGRAM_DATE_FORMAT = 'MMM-DD-YYYY'

export const CREATE_OR_UPDATE_PROGRAMS_TABS = ['Information', 'Settings']
export const CREATE_OR_UPDATE_PROGRAMS_TABS_INDEX = {
  INFORMATION: 0,
  SETTINGS: 1
} as const

export const CREATE_OR_EDIT_PROGRAM_KEYS = {
  NAME: 'Name',
  DESCRIPTION: 'Description',
  START_DATE: 'StartDateUTC',
  END_DATE: 'EndDateUTC',
  DISTRIBUTION_TYPE: 'DistributionType',
  PARTICIPANTS_LIMIT: 'UserLimit',
  VALUE_OF_TRIP: 'ValueOfTrip',
  ENTER_CODE: 'EnterCode',
  CODE_GENERATION_METHOD: 'CodeGenerationMethod',
  NUMBER_OF_CODES: 'NumberOfCodes',
  PREFIX: 'Prefix',
  EXCLUDED_CHARACTERS: 'ExcludedCharacters',
  CODE_LENGTH: 'CodeLength',
  TIMES_CAN_BE_ENTERED_BY_USER: 'TimesCanBeEnteredByUser',
  SCAN_RECEIPT: 'ScanReceipt',
  BUSINESS_USER_ID: 'BusinessUserID',
  EDIT_AVAILABLE_CODES: 'editAvailableCodesType',
  ACTIVE_TICKETS_URL: 'ProgramActiveTicketsURL',
  SET_PURCHASE_DAY: 'setPurchaseDay',
  SET_PURCHASE_TIME: 'setPurchaseTime',
  SET_RECEIPT_AMOUNT: 'setReceiptAmount',
  RECEIPT_MIN_AMOUNT: 'ReceiptMinAmount',
  RECEIPT_MAX_AMOUNT: 'ReceiptMaxAmount',
  PURCHASE_DAYS: 'purchaseDays',
  PURCHASE_TIMES: 'purchaseTimes',
  RECEIPT_AMOUNT_OPTION: 'receiptAmountOption',
  NUMBER_OF_RECEIPTS: 'NumberOfReceipts'
}
export const SELECT_BUSINESS_PLACEHOLDER = 'Select Business'
export const ROW_STYLE = 'flex flex-row justify-between p-3 mt-5'
export const COL_STYLE = 'flex flex-col w-3/5 space-y-3'

export const PROGRAM_DISTRIBUTION_TYPES = {
  ONE_WAY_TRIP: 'ONE_WAY_TRIP',
  TWO_WAY_TRIP: 'TWO_WAY_TRIP',
  REWARD_POINTS: 'REWARD_POINTS'
}

export const PROGRAM_DISTRIBUTION_TYPES_SELECT_OPTIONS: {
  key: string
  label: string
}[] = [
  {
    key: PROGRAM_DISTRIBUTION_TYPES.ONE_WAY_TRIP,
    label: 'One-Way Trip'
  },
  {
    key: PROGRAM_DISTRIBUTION_TYPES.TWO_WAY_TRIP,
    label: 'Two-Way Trip'
  }
]

export const PROGRAM_CODE_GENERATION_METHODS = {
  GENERAL: 'GENERAL',
  CUSTOM: 'CUSTOM'
}

export const PROGRAM_CODE_GENERATION_METHODS_SELECT_OPTIONS: {
  key: string
  label: string
}[] = [
  {
    key: PROGRAM_CODE_GENERATION_METHODS.GENERAL,
    label: 'General (generated random code)'
  },
  { key: PROGRAM_CODE_GENERATION_METHODS.CUSTOM, label: 'Custom Code' }
]

export const PROGRAM_CODE_LENGTH_OPTIONS = ['4', '5', '6'].map((length) => ({
  label: length,
  value: length
}))

export const PROGRAM_OPTIONS_ACTION_TYPE = {
  STATUS: 'status',
  DELETE_CODE: 'deleteCode',
  DOWNLOAD_CODES: 'downloadCodes',
  DELETE_PROGRAM: 'deleteProgram',
  DUPLICATE: 'duplicate'
}

export const PROGRAM_OPTIONS_ACTION_BUTTON_LABELS = {
  STATUS: 'Change Status',
  DELETE_CODE: 'Delete All Available Codes',
  DOWNLOAD_CODES: 'Download List of Available Codes',
  DELETE_PROGRAM: 'Delete Program',
  DUPLICATE: 'Duplicate Program'
}

export const CREATED_DATE = 'Created Date'

export const DETAILS_CARD_COMMON_CLASSNAMES = 'my-3 border-[#E5E7EB] shadow-md'

export const DETAILS_CARD_LAST_INDEX = 3

export const PROGRAM_DETAILS_LEFT_CARD_ITEMS = {
  StartDateUTC: 'Start Date',
  EndDateUTC: 'End Date',
  Description: 'Description'
}

export const BUSINESS_USER_DETAILS_LEFT_CARD_ITEMS = {
  BusinessUserID: 'BusinessID',
  Name: 'Business Name',
  Email: 'Email',
  Description: 'Description'
}

export const PROGRAM_DETAILS_IMAGE = {
  WIDTH: 160,
  HEIGHT: 80
}

export const PROGRAM_DETAILS_TABS_INDEX = {
  SETTINGS: 0,
  CODES: 1,
  RECEIPTS_SCANNED: 2
}

export const PROGRAM_DETAILS_TABS = ['Settings', 'Codes', 'Receipts Scanned']

export const PROGRAM_DETAILS_TABS_CONTENT = {
  SETTINGS: {
    TITLE: {
      ACCESS_TO_PROGRAM: 'Access to the Program',
      REWARDS_SETTINGS: 'Rewards Settings',
      CODES_SUMMARY: 'Codes Summary',
      RECEIPTS_SETTINGS: 'Receipts Settings'
    },
    SUBTITLE: {
      ACCESS_TO_PROGRAM:
        'How the users will access to the program as well as the benefit they will received.',
      REWARDS_SETTINGS:
        'Type of Reward the user will receive once he participates in the program.',
      CODES_SUMMARY:
        'The users will be able to participate in the program by entering a code in their Rewards account.',
      RECEIPTS_SETTINGS:
        'Rules defined for a scanned receipt to be used to participate in the program.'
    },
    LABELS: {
      JOIN_METHOD: 'Option to enter the Program',
      DISTRIBUTION_TYPE: 'Value to Distribute',
      PARTICIPANTS_LIMIT:
        'Limit the times the user can participate in the Program',
      VALUE_OF_TRIP: 'Value of Trip (in USD)',
      NUMBER_OF_RECEIPTS: 'Number of Receipts',
      DAYS_TO_PURCHASE:
        'Select a specific day when the purchase needs to happen',
      TIME_FRAME:
        'Select a specific time frame when the purchase needs to happen',
      RECEIPT_AMOUNT: 'Specific Receipt Amount',
      TOTAL_CREATED_CODES: 'Total Codes Created',
      AVAILABLE_CODES: 'Available Codes',
      REDEEMED_CODES: 'Redeemed Codes',
      ACTIVE_TICKETS_EXTERNAL_URL:
        'External URL where user will see the active tickets:',
      RECEIPT_AMOUNT_OPTION: 'Receipt Amount',
      RECEIPT_MIN_AMOUNT: 'Min $ Amount',
      RECEIPT_MAX_AMOUNT: 'Max $ Amount'
    }
  }
}

export const PROGRAM_JOIN_METHODS_VALUES = {
  ENTER_CODE: 'Entering a Code',
  SCAN_RECEIPT: 'Scanning a purchase receipt'
}

export const PROGRAM_CODES_STATUSES = {
  AVAILABLE: 'Available',
  REDEEMED: 'Redeemed'
}

export const PROGRAM_CODES_TABLE_COLUMNS = [
  'Code',
  'Created Date',
  'Status',
  'Redeem Date',
  'User',
  ' '
]

export const PROGRAM_CODES_ACTION = {
  REDEEMED: 'Refund Points',
  AVAILABLE: 'Delete Code'
}

export const DELETE = 'DELETE'
export const DOWNLOAD_AVAILABLE = 'DOWNLOAD_AVAILABLE'
export const DOWNLOAD_CREATED = 'DOWNLOAD_CREATED'

export const PROGRAM_CODES_OPTIONS_MENU = [
  {
    title: DELETE,
    value: 'Delete All Available Codes'
  },
  {
    title: DOWNLOAD_AVAILABLE,
    value: 'Download List of Available Codes'
  },
  {
    title: DOWNLOAD_CREATED,
    value: 'Download List of Created Codes'
  }
]

export const NO_AVAILABLE_CODES = 0

export const PROGRAM_CODES_FILTER = {
  SEARCH: 'search',
  REDEEM_RANGE: 'redeemDateRange',
  STATUSES: 'selectedStatuses'
}
export const BOLD_WORDS = 'font-bold'

export const SEARCH_PROGRAM_CODES_ACTION = 'SEARCH_PROGRAM_CODES'

export const MORE_OPTIONS = 'More'

export const EDIT_PROGRAM = 'Edit Program'

export const OPTIONS = 'Options'

export const CODE_TABLE_TITLE = 'List of Codes for the Program:'

export const NO_AVAILABLE_CODE_MESSAGE = 'Code no longer Available'

export const DELETE_AVAILABLE_CODE_MESSAGE = 'Delete Available Code'

export const DELETE_CODE_BUTTON_LABEL = 'Delete Code'

export const EDIT_AVAILABLE_CODES_OPTIONS = [
  { key: 'delete-all', label: 'Delete all available codes' },
  {
    key: 'replace-list',
    label: 'Replace the list of available codes with new codes'
  },
  { key: 'generate-more', label: 'Generate more codes' },
  { key: 'no-modifications', label: "Don't make any modifications" }
]

export const DEFAULT_EDIT_AVAILABLE_CODES_OPTION = 'no-modifications'

export const GENERATION_METHOD_TEXT = {
  GENERAL: 'General (generated random code)',
  CUSTOM: 'Custom Code'
}

export const CUSTOM_CODE_CONFIG_FILEDS_PLACEHOLDERS = {
  PREFIX: 'Enter prefix',
  CODE_LENGTH: 'Select number of characters',
  EXCLUDED_CHARACTERS: 'Comma-separated list of characters'
}

export const EDIT_AVAILABLE_CODES_OPTIONS_KEYS = {
  DELETE_CODES: 'delete-all',
  REPLACE_CODES: 'replace-list',
  GENERATE_CODES: 'generate-more',
  NO_MODIFICATIONS: 'no-modifications'
}

export const PROGRAM_RECEIPTS_TABLE_COLUMNS = [
  'ID',
  'Uploaded Date',
  'Receipt Date',
  'Receipt Number',
  'Receipt Amount',
  'User',
  ' '
]

export const RECEIPTS_TABLE_TITLE = 'List of Valid Receipts Scanned:'

export const NOT_SUPPORTED_TEXT =
  'This Program doesn’t support to access by entering a Scanning a Receipt.'

export const SEARCH_PROGRAM_RECEIPTS_ACTION = 'SEARCH_PROGRAM_RECEIPTS'

export const RECEIPTS_FILTERS_KEYS = {
  SEARCH: 'search'
}

export const PROGRAM_RECEIPT_SPECIFIC_DAYS = [
  { label: 'Monday', value: '1' },
  { label: 'Tuesday', value: '2' },
  { label: 'Wednesday', value: '3' },
  { label: 'Thursday', value: '4' },
  { label: 'Friday', value: '5' },
  { label: 'Saturday', value: '6' },
  { label: 'Sunday', value: '7' }
]

export const RECEIPT_AMOUNT_OPTIONS = [
  { label: 'Between', value: 'Between' },
  { label: 'More than', value: 'More' },
  { label: 'Less than', value: 'Less' }
]

export const RECEIPT_DEFAULT_TIME = {
  FROM_HOUR: '00',
  FROM_MINUTE: '00',
  TO_HOUR: '23',
  TO_MINUTE: '59'
}

export const ISO_DAYS_VALUES = ['1', '2', '3', '4', '5', '6', '7']

export const TIME_RANGE_ERROR_MSG = 'End time must be after start time'

export const TIME_CONSTANTS = {
  HOURS_PER_DAY: 24,
  MINUTES_PER_HOUR: 60,
  TOTAL_MINUTES_PER_DAY: 24 * 60,
  MINUTES_OFFSET_FOR_END_TIME: 1,
  TIME_FORMAT_PADDING_LENGTH: 2,
  TIME_FORMAT_PADDING_CHAR: '0'
} as const
